<app-header></app-header>

<!-- Title -->
<div class="section-lg bg-image parallax" style="background-image: url('assets/images/backgrounds/title-bg-1.jpg');">
  <div class="bg-dark-07">
    <div class="container">
      <div class="row g-4">
        <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 text-center">
          <h1 class="fw-black m-0 display-4">Portfolio Two</h1>
          <h2 class="fw-thin uppercase">CREATIVE DIGITAL AGENCY SINCE 2004</h2>
        </div>
      </div><!-- end row -->
    </div><!-- end container -->
  </div>
</div>
<!-- end Title -->

<!-- Portfolio section -->
<div class="section">
    <div class="container">
        <!-- Portfolio filter -->
        <div class="filter filter-style-3 mb-5 text-center">
            <ul>
                <li *ngFor="let filter of portfolioFilters" [class.active]="selectedFilter === filter" (click)="filterPortfolio(filter)">
                    {{filter}}
                </li>
            </ul>
        </div>
        <!-- end Portfolio filter -->
        <div class="row portfolio-grid g-2 hover-style-1">
            <!-- Portfolio box -->
            <div *ngFor="let item of portfolioItems; let i = index" [ngClass]="{'col-12 col-md-6 col-lg-6 portfolio-item': true, 'hidden': !isPortfolioVisible(item)}" [attr.data-category]="item.categories.join(' ')">
                <div class="portfolio-box">
                    <div class="portfolio-img">
                        <img [src]="item.img" [alt]="item.alt">
                    </div>
                    <a routerLink="/portfolio-one"></a>
                    <div class="portfolio-title">
                        <div>
                            <h4 class="fw-medium">{{item.title}}</h4>
                            <span>{{formatCategories(item.categories) | titlecase}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div><!-- end row/portfolio-grid-->
    </div><!-- end container -->
</div>
<!-- end Portfolio section -->

<!-- Clients section -->
<div class="section pt-0">
  <div class="container">
    <owl-carousel-o [options]="brandsCarousel" class="owl-btn-center-lr brands-carousel">
        <ng-template carouselSlide *ngFor="let brand of brandStore">
            <div class="client-box">
                <a href="#."><img src="assets/images/brands/{{brand.img}}" alt="brand-img"></a>
            </div>
        </ng-template>
    </owl-carousel-o>
  </div><!-- end container -->
</div>
<!-- end Clients section -->

<footer class="footer footer-three">
  <div class="footer-main">
    <div class="container">
      <div class="row">
        <!-- ABOUT -->
        <div class="col-sm-6 col-md-3">
          <div class="widget widget-links">
            <h5 class="widget-title">About Us</h5>
            <div class="footer-about">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                In at purus varius odio tempus cursus. vitae, commodo dui.
              </p>
              <ul class="social-media">
                <li *ngFor="let social of socialLinks">
                  <a [href]="social.url" class="bi" [ngClass]="social.icon"></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- QUICK LINKS -->
        <div class="col-sm-6 col-md-2">
          <div class="widget widget-links">
            <h5 class="widget-title">Quick Links</h5>
            <ul>
              <li *ngFor="let link of quickLinks">
                <a [href]="link.url">{{link.name}}</a>
              </li>
            </ul>
          </div>
        </div>
        <!-- RECENT POSTS -->
        <div class="col-sm-6 col-md-4">
          <div class="widget widget-links">
            <h5 class="widget-title">Recent Post</h5>
            <div class="row post-sm-content" *ngFor="let post of recentPosts; let i=index" [class.mrt-20]="i > 0">
              <div class="col-md-3 col-sm-3 col-xs-3">
                <img class="img-overlay border-radius-100" [src]="post.image" alt="post">
              </div>
              <div class="col-md-9 col-sm-9 col-xs-9">
                <h6>{{post.title}}</h6>
                <p>{{post.desc}}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- CONTACT -->
        <div class="col-sm-6 col-md-3">
          <div class="widget widget-text">
            <h5 class="widget-title">Contact Us</h5>
            <ul class="footer-contact">
              <li>
                <i class="bi bi-pin-fill"></i>
                <p>Schönhauser Allee 167c 10435 Berlin Germany</p>
              </li>
              <li>
                <i class="bi bi-envelope"></i>
                <p>
                  <a href="mailto:yoursite@gmail.com">
                    yoursite&#64;gmail.com
                  </a>
                </p>
              </li>
              <li>
                <i class="bi bi-phone-fill"></i>
                <p>+49 30 47373795</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- COPYRIGHT -->
  <div class="footer-copyright">

    <div class="container">

      <div class="row d-flex justify-content-center">
        <div class="col-md-2">

          <div class="logo-footer">
            <a routerLink="/">
              <img class="img-responsive" src="assets/images/logo-footer.png" alt="footer-logo">
            </a>
          </div>

        </div>
      </div>


      <div class="row">
        <div class="col-md-12">

          <div class="copy-right"> © Copyright 2026 Chaos. Designed By <a href="https://themeforest.net/user/designsninja/portfolio" target="_blank">
              DesignsNinja
            </a>
          </div>

        </div>
      </div>

    </div>

  </div>

</footer>

